import {
  parseJSONWithBetterErrors,
  fetchWithErrorHandling,
  throwErrorsIfBadResponse,
} from '@github-ui/pull-request-page-data-tooling/fetch-error-handling'
import {useMutation} from '@github-ui/react-query'
import {ssrSafeWindow} from '@github-ui/ssr-utils'
import {pullRequestApplyAutomatedSuggestionPath} from '@github-ui/paths'
import {usePullRequestBasePath} from '../stores/selectors'

/**
 * Applies automated suggestion for an automated review comment
 */
export function useApplyAutomatedSuggestionMutation(automatedCommentId: string) {
  const basePath = usePullRequestBasePath()

  const apiUrl = pullRequestApplyAutomatedSuggestionPath({basePath, automatedReviewCommentId: automatedCommentId})

  return useMutation({
    mutationFn: async ({message}: {message: string}) => {
      const response = await fetchWithErrorHandling(apiUrl, {
        method: 'POST',
        body: {
          message,
        },
      })

      const json = await parseJSONWithBetterErrors(response)
      throwErrorsIfBadResponse(response, json)
      return json
    },
    onSuccess: () => {
      // TODO(@aliceclv): double check that it's the intended behavior
      // We want to reload so we get the updated diff
      ssrSafeWindow?.location.reload()
    },
  })
}
